import { Link } from '@mui/material';
import { ErrorPage } from 'components/system/ErrorPage';
import { SUPPORT_EMAIL } from 'constants/info';

export const Page404 = () => {
  return (
    <ErrorPage
      code={404}
      title="Page not found"
      message="We are sorry for the inconvenience. If you think this is an error please contact our support team at:"
      action={
        <Link
          sx={{
            color: 'inherit',
            textDecoration: 'none',
            fontSize: 'h4.fontSize',
          }}
          href={`mailto:${SUPPORT_EMAIL}`}
        >
          {SUPPORT_EMAIL}
        </Link>
      }
    />
  );
};
